// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2dPmS","gfeWrapper":"CalendarEvent_gfeWrapper__2lRiy"};